import React from 'react';
import { Section } from './ui/Section';
import { useMetaPixelViewTracking, trackEvent } from '../utils/metaPixel';
export function Pricing() {
  useMetaPixelViewTracking('pricing', {
    content_category: 'pricing',
    content_type: 'product'
  });
  const handlePackClick = (packName: string, price: string) => {
    trackEvent('InitiateCheckout', {
      content_name: packName,
      value: parseFloat(price),
      currency: 'EUR'
    });
  };
  return <Section id="pricing" data-id="element-149">
      <div className="text-center mb-6" data-id="element-150">
        <h2 className="font-display text-2xl md:text-4xl font-bold mb-3 text-brand-primary" data-id="element-151">
          💰 ELIGE TU PACK
        </h2>
        <div className="inline-block bg-red-50 border-2 border-red-500 rounded-lg px-4 py-2 mb-4" data-id="element-152">
          <div className="font-body text-red-600 font-bold text-sm" data-id="element-153">
            ⏰ OFERTA DE LANZAMIENTO
          </div>
          <div className="font-heading text-2xl font-bold text-brand-primary line-through" data-id="element-154">
            70€
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-6" data-id="element-155">
        {/* Base */}
        <div className="bg-white border-2 border-brand-border rounded-lg p-6 shadow-card" data-id="element-156">
          <div className="text-center mb-4" data-id="element-157">
            <h3 className="font-heading text-xl font-bold text-brand-primary mb-2" data-id="element-158">
              OFERTA BASE
            </h3>
            <div className="font-display text-4xl font-bold text-brand-primary mb-1" data-id="element-159">
              13,99€
            </div>
            <div className="text-brand-textMuted text-xs line-through" data-id="element-160">
              Valor: 70€
            </div>
          </div>

          <div className="mb-4 space-y-1 text-sm" data-id="element-161">
            {['6 Tomos completos', '3 Bonos (57€)', 'Acceso inmediato', 'PDF + Word editable'].map((f, i) => <div key={i} className="flex items-center gap-2" data-id="element-162">
                <span className="text-green-500 text-xs" data-id="element-163">✓</span>
                <span className="font-body text-brand-text" data-id="element-164">{f}</span>
              </div>)}
          </div>

          <a href="https://www.digipromarket.com/cart/56674902311238:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Base', '13.99')} className="block w-full bg-white border-2 border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white font-body font-bold text-base py-3 rounded-lg transition-all text-center" data-id="element-165">
            ELEGIR BASE
          </a>
        </div>

        {/* Premium */}
        <div className="bg-gradient-navy text-white border-2 border-brand-accent rounded-lg p-6 shadow-gold relative" data-id="element-166">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-gold text-brand-primary font-heading font-bold px-4 py-1 rounded-full text-xs shadow-gold animate-pulse" data-id="element-167">
            ⭐ MÁS ELEGIDA
          </div>

          <div className="text-center mb-4" data-id="element-168">
            <h3 className="font-heading text-xl font-bold mb-2" data-id="element-169">
              OFERTA PREMIUM
            </h3>
            <div className="font-display text-4xl font-bold text-brand-accent mb-1" data-id="element-170">
              19,99€
            </div>
            <div className="text-white/60 text-xs line-through" data-id="element-171">Valor: 99€</div>
          </div>

          <div className="mb-4 space-y-1 text-sm" data-id="element-172">
            {['Todo lo de Base', '💎 Pack Legal (79€)', '💎 Contratos RGPD', '💎 Documentación clínica'].map((f, i) => <div key={i} className="flex items-center gap-2" data-id="element-173">
                <span className="text-brand-accent text-xs" data-id="element-174">✓</span>
                <span className="font-body text-white" data-id="element-175">{f}</span>
              </div>)}
          </div>

          <a href="https://www.digipromarket.com/cart/56674947498310:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Premium', '19.99')} className="block w-full bg-gradient-gold text-brand-primary hover:opacity-90 font-body font-bold text-base py-3 rounded-lg transition-all text-center shadow-gold" data-id="element-176">
            🚀 QUIERO PREMIUM
          </a>
        </div>
      </div>

      <div className="bg-brand-accent/10 border-2 border-brand-accent rounded-lg p-4 max-w-2xl mx-auto text-center" data-id="element-177">
        <p className="font-body text-brand-text font-bold text-sm" data-id="element-178">
          💡 +6€ = Pack Legal completo (99€) • 94% eligen Premium
        </p>
      </div>
    </Section>;
}